import {
  Box, Menu, MenuItem as MuiMenuItem, styled,
} from '@mui/material';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import {
  Dispatch, SetStateAction, useRef, useState, type JSX,
} from 'react';
import CustomButton from '@/components/Common/Button';
import ExportOptionsPopover from '@/components/Common/Export/ExportOptionsPopover';
import { biomaterialsExportOptions } from '@/constants/PatientDashboard/biomaterialsExport';
import { IBiomaterialRow } from '@/types/PatientDashboard/TimelineView.types';

const MenuItem = styled(MuiMenuItem)(() => ({
  width: '260px',
}));

interface IProps {
  rows: IBiomaterialRow[];
  showSubmissions: boolean;
  onToggleSubmissions: () => void;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
}

export default function BiomaterialsTableMoreOptionsButton({
  rows,
  showSubmissions,
  onToggleSubmissions,
  loading,
  setLoading,
}: IProps): JSX.Element {
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);
  const [exportAnchorEl, setExportAnchorEl] = useState<HTMLElement | null>(null);

  const buttonRef = useRef<HTMLButtonElement | null>(null);

  return (
    <Box
      height="100%"
      display="flex"
      alignItems="center"
      padding="0px 8px"
    >
      <CustomButton
        ref={buttonRef}
        variant="text"
        size="small"
        label="More Options"
        endIcon={menuAnchorEl ? (
          <ChevronUpIcon />
        ) : (
          <ChevronDownIcon />
        )}
        onClick={(e): void => setMenuAnchorEl(e.currentTarget)}
      />
      <Menu
        open={Boolean(menuAnchorEl)}
        anchorEl={menuAnchorEl}
        onClose={(): void => setMenuAnchorEl(null)}
      >
        <MenuItem
          onClick={(): void => {
            onToggleSubmissions();
            setMenuAnchorEl(null);
          }}
        >
          {showSubmissions ? 'Show biomaterials' : 'Show previous submissions'}
        </MenuItem>
        <MenuItem
          onClick={(): void => {
            setExportAnchorEl(buttonRef.current);
            setMenuAnchorEl(null);
          }}
        >
          Export biomaterials
        </MenuItem>
      </Menu>
      <ExportOptionsPopover
        anchorEl={exportAnchorEl}
        onClose={(): void => setExportAnchorEl(null)}
        exportOptions={biomaterialsExportOptions}
        getData={(): IBiomaterialRow[] => rows}
        filenamePrefix="Biomaterials"
        loading={loading}
        setLoading={setLoading}
      />
    </Box>
  );
}
